import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiDriverInterfaceService } from '../api-interface/api-driver-interface';
import { ApiInterfaceService } from '../api-interface/api-interface.service';

@Injectable({
    providedIn: 'root',
})
export class DriverService {
    constructor(
        private readonly apiInterfaceService: ApiInterfaceService,
        private readonly apiDriverInterfaceService: ApiDriverInterfaceService
    ) {}

    getDetails(): Observable<any> {
        return this.apiDriverInterfaceService.get(
            'driver/basic_details/',
            null
        );
    }

    saveDetails(id: any, payload: any): Observable<any> {
        return this.apiDriverInterfaceService.patch(
            `driver/update_activity_level/${id}/`,
            payload
        );
    }

    createFedexReturn(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.post(
            'driver/generate_fedex_return/',
            payload
        );
    }

    setExtendedPause(): Observable<any> {
        return this.apiInterfaceService.post('set_extended_pause', null);
    }

    endAccountPause(): Observable<any> {
        return this.apiInterfaceService.post('end_account_pause', null);
    }

    reactivateD60Account(): Observable<any> {
        return this.apiDriverInterfaceService.post(
            'driver/reactivate_d60_account/',
            null
        );
    }

    getMarkets(): Observable<any> {
        return this.apiDriverInterfaceService.get('driver/markets/', null);
    }

    getPreferredLanguages(): Observable<any> {
        return this.apiDriverInterfaceService.get(
            'driver/preferred_languages/',
            null
        );
    }

    getContractDetails(): Observable<any> {
        return this.apiDriverInterfaceService.getV2('driver/contract/', null);
    }

    saveContractDetails(id: any, payload: any): Observable<any> {
        return this.apiDriverInterfaceService.patchV2(
            `driver/contract/${id}/`,
            payload
        );
    }
    updateAddress(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.post('driver/address/', payload);
    }
    getFedExSuggestion(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.get(
            'driver/fedex_address_suggestion/',
            payload
        );
    }
    getBillingDetails(): Observable<any> {
        return this.apiDriverInterfaceService.get(
            'driver/billing_details/',
            null
        );
    }
    saveBillingDetails(id: any, payload: any): Observable<any> {
        return this.apiDriverInterfaceService.patch(
            `driver/billing_details/${id}/`,
            payload
        );
    }
    updateNumber(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.post(
            'driver/update_number/',
            payload
        );
    }
    uploadImage(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.saveFormData(
            'driver/file-upload/',
            payload
        );
    }
    updateProfile(id: any, payload: any): Observable<any> {
        return this.apiDriverInterfaceService.patch(
            `driver/profile/${id}/`,
            payload
        );
    }
    verifyInitiative(
        initiative: string,
        token: string,
        driverResponse: string
    ): Observable<any> {
        return this.apiInterfaceService.get(
            `driver/response/${initiative}/${token}/${driverResponse}/`,
            null
        );
    }
    makeTia(token: string): Observable<any> {
        return this.apiInterfaceService.get(
            `driver/response/make-tia/${token}/`,
            null
        );
    }
    getNewsFeed(): Observable<any> {
        return this.apiDriverInterfaceService.get('driver/news-feed/', null);
    }
    getFedExLocations(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.get(
            'driver/fedex/location_lookup/',
            payload
        );
    }

    selectFedExLocation(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.post(
            'driver/fedex/pickup/',
            payload
        );
    }
    connectUberAccount(payload: any): Observable<any> {
        return this.apiDriverInterfaceService.post(
            'driver/uber/connect/',
            payload
        );
    }

    removeUberAccountWithSurvey(url: string): Observable<any> {
        return this.apiDriverInterfaceService.delete(
            url,
            ''
        );
    }

    touchContactInfo() {
        return this.apiDriverInterfaceService.post(
            'driver/contact-info/',
            null,
        );
    }

    updateContactDetail(id: string | number, payload: { email?: string; phone_number?: string; otp?: any }) {
        return this.apiDriverInterfaceService.patch(
            `driver/contact-detail/${id}/`,
            payload
        );
    }

    removeUberAccount(source: string): Observable<any> {
        return this.apiDriverInterfaceService.delete(
           'driver/uber/connect/',
            '',
            source
        );
    }
    skipUberConnection(): Observable<any> {
        return this.apiDriverInterfaceService.post(
            'driver/uber/connect/?action=skip',
            {}
        );
    }
}
